import{post } from '@/utils/request';
import{erpplatserver,erpserver} from '@/utils/baseUrl';

//产品类标
export async function list(params) {
    return post(erpserver+'/productmanage/list', params, true)
}
//产品树
export async function getProductTree(params) {
    return post(erpplatserver+'/systemtree/getProductTree', params, true)
}
//产品属性
export async function listpzsx(params) {
    return post(erpserver+'/productmanage/listpzsx', params, true)
}
export async function edit(params) {
    return post(erpserver+'/productmanage/edit', params, true)
}